/* import {KTIcon} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub' */
import { useEffect, useState } from 'react'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useGetUser } from '../../../../../app/tfi/store/userStore'
import { hasPermission, isAdministrator } from '../../../../../app/tfi/helpers'
import { ALL_PERMISSIONS } from '../../../../../app/tfi/helpers/consts'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { useQuery } from '@apollo/client'
import { GET_UNREAD_NOTIFICATIONS_COUNT } from '../../../../../app/tfi/gql/queries/notificationsQuery'
import axios from 'axios'
import { STORAGE_NAMES } from '../../../../../app/tfi/helpers/consts'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000'

const SidebarMenuMain = () => {
  const user = useGetUser((s) => s.user)
  const permissions = useGetUser((user) => user?.user?.permissions)
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const isAgente = userGroups.includes('Agente')
  const isSupervisor = userGroups.includes('Supervisor')
  const { data: unreadData, refetch: refetchUnreadCount } = useQuery(GET_UNREAD_NOTIFICATIONS_COUNT, {
    fetchPolicy: 'network-only',
    pollInterval: 120000, // refresh every 2 minutes
    skip: !user, // Skip if no user
  })
  const unreadCount = unreadData?.unreadNotificationsCount ?? 0

  // Refetch unread count when user changes
  useEffect(() => {
    if (user) {
      refetchUnreadCount()
    }
  }, [user, refetchUnreadCount])

  // Fetch Inbox Unread Count (REST)
  const [inboxUnreadCount, setInboxUnreadCount] = useState(0)

  useEffect(() => {
    if (!user) return

    const fetchInboxCount = async () => {
      try {
        const token = localStorage.getItem(STORAGE_NAMES.TOKEN)
        if (!token) return

        const response = await axios.get(`${API_URL}/api/chat/unread-count`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        setInboxUnreadCount(response.data.count)
      } catch (error) {
        console.error('Error fetching inbox count', error)
      }
    }

    fetchInboxCount()
    const interval = setInterval(fetchInboxCount, 60000) // Poll every 60s

    return () => clearInterval(interval)
  }, [user])

  if (!permissions) return null

  return (
    <>
      {(isAdministrator(permissions) || isAgente || isSupervisor) &&
        hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
          <SidebarMenuItem
            to='/dashboard/policy'
            title='Dashboard'
            fontIcon='bi-speedometer2'
          />
        )}
      <SidebarMenuItem
        to='/calendar'
        title='Calendar'
        fontIcon='bi-calendar3'
      />
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD) && (
        <SidebarMenuItem
          to='/leads'
          // icon='simcard'
          // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          title='Leads'
          fontIcon='bi-person-vcard'
        />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_TASKS) && (
        <SidebarMenuItem to='/kanban' title='Tasks' fontIcon='bi-kanban' />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_CAMPAIGNS) && (
        <SidebarMenuItemWithSub to='/campaigns' title='Campaigns' fontIcon='bi-megaphone' icon='element-plus'>
          <SidebarMenuItem to='/campaigns' title='Campaigns' hasBullet />
          <SidebarMenuItem to='/templates' title='Templates' hasBullet />
          <SidebarMenuItem to='/recipients' title='Recipients' hasBullet />
          <SidebarMenuItem to='/media-manager' title='Media Manager' hasBullet />
        </SidebarMenuItemWithSub>
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_USER) && (
        <SidebarMenuItem
          to='/users'
          // icon='simcard'
          // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          title='Users'
          fontIcon='bi-people'
        />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
        <SidebarMenuItem
          to='/policies'
          // icon='simcard'
          // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          title='Policies'
          fontIcon='bi-shield-check'
        />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
        <SidebarMenuItem
          to='/quotes'
          // icon='simcard'
          // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          title='Quotes'
          fontIcon='bi-clipboard-data'
        />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_CONTACT) && (
        <SidebarMenuItem
          to='/medicare-center'
          title='Medicare Center'
          fontIcon='bi-hospital'
        />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_SIGNATURE_FORMS) && (
        <SidebarMenuItem
          to='/signature-forms'
          // icon='simcard'
          // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          title='Signature forms'
          fontIcon='bi-filetype-pdf'
        />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_CONTACT) && (
        <SidebarMenuItem
          to='/contacts'
          // icon='simcard'
          // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          title='Contacts'
          fontIcon='bi-telephone-fill'
        />
      )}

      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMISSION) && (
        <SidebarMenuItem
          to='/commissions'
          // icon='simcard'
          // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          title='Commissions'
          fontIcon='bi-piggy-bank'
        />
      )}
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_RESOURCE_CENTER) && (
        <SidebarMenuItem to='/resource-center' title='Resource Center' fontIcon='bi-folder2-open' />
      )}
      <SidebarMenuItem
        to='/notifications'
        title='Notifications'
        fontIcon='bi-bell'
        badge={unreadCount > 0 ? unreadCount : undefined}
      />
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_INTEGRATION) && (
        <SidebarMenuItem
          to='/integrations'
          // icon='simcard'
          // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          title='Integrations'
          fontIcon='bi-diagram-3'
        />
      )}
      <SidebarMenuItem
        to='/inbox'
        title='Inbox'
        fontIcon='bi-chat-square-text'
        badge={inboxUnreadCount > 0 ? inboxUnreadCount : undefined}
      />
      {/* <SidebarMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <SidebarMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='profile-circle'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='element-7'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='message-text-2'
      >
        <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='/apps/user-management/users'
        icon='abstract-28'
        title='User management'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTIcon iconName='code' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}

export { SidebarMenuMain }
